module.exports = __webpack_public_path__ + "img/cpzz7@2x.ea262a6c.png";